module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/three-phase-panel/PanelTexture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/three-phase-panel/PanelTexture.png
// module id = 639
// module chunks = 0